import React, { useState } from 'react'

import Option from './Option'
import SearchBar from './SearchBar'
import { useStateValue } from './StateProvider'

const Right = () => {
  const [{ countryStats, searchText }] = useStateValue()

  const filterCountriesStats = () => {
    // Function to filter on the country name based on the text the user enters within the input field.
    let filteredCountriesStats = []
        
    // If-else statement to see whether there actually is text inserted to prevent no countries from being list.
    if (searchText.length > 0) {
        // RegEx to check whether the country name is included within the searchText.
        const regex = new RegExp(searchText, 'i')
        countryStats.forEach(country => {
            if (regex.test(country.country)) {
              filteredCountriesStats.push(country)
            }
        })
    } else {
      return countryStats
    }

    return filteredCountriesStats  
  }

  return (
    <div className='right'>
      <SearchBar />
      <div className='right__list'>
        {countryStats.length > 0 && filterCountriesStats().map((country, index) => <Option country={country} id={index} key={index} />)}
      </div>
    </div>
  )
}

export default Right